var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 1.6665H5.83341C5.39139 1.6665 4.96746 1.8421 4.6549 2.15466C4.34234 2.46722 4.16675 2.89114 4.16675 3.33317V17.4998C4.16675 17.7208 4.25455 17.9328 4.41083 18.0891C4.56711 18.2454 4.77907 18.3332 5.00008 18.3332H15.0001C15.2211 18.3332 15.4331 18.2454 15.5893 18.0891C15.7456 17.9328 15.8334 17.7208 15.8334 17.4998V3.33317C15.8334 2.89114 15.6578 2.46722 15.3453 2.15466C15.0327 1.8421 14.6088 1.6665 14.1667 1.6665ZM9.16675 13.3332H6.66675V11.6665H9.16675V13.3332ZM9.16675 9.99984H6.66675V8.33317H9.16675V9.99984ZM9.16675 6.6665H6.66675V4.99984H9.16675V6.6665ZM13.3334 13.3332H10.8334V11.6665H13.3334V13.3332ZM13.3334 9.99984H10.8334V8.33317H13.3334V9.99984ZM13.3334 6.6665H10.8334V4.99984H13.3334V6.6665Z",
    fill: "#c3c3c3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarIcon4);
export default __webpack_public_path__ + "static/media/navbar-icon4.778a939205ec3f60cf0579b5d07ebfca.svg";
export { ForwardRef as ReactComponent };